module.exports = __webpack_public_path__ + "img/img_banner_title.3f4dd3f4.png";